import { useCallback, useRef, useState } from "react";

export const getDetailTabPanelContentKey = (tabValue: string, activeTab: string, enterKey: number) =>
    activeTab === tabValue ? `enter-${enterKey}` : `standby-${tabValue}`;

const useDetailTabSwitch = (initialTab: string) => {
    const [value, setValue] = useState(initialTab);
    const [tabEnterKey, setTabEnterKey] = useState(0);
    const containerRef = useRef<HTMLDivElement>(null);

    const scrollPanelToTop = useCallback(() => {
        containerRef.current
            ?.closest(".works-right-panel, .title-detail-scroll, .detail-panel-scroll")
            ?.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const switchTab = useCallback(
        (newValue: string) => {
            if (newValue === value) return;
            setValue(newValue);
            setTabEnterKey((currentKey) => currentKey + 1);
            scrollPanelToTop();
        },
        [scrollPanelToTop, value],
    );

    const handleTabChange = useCallback(
        (_event: React.SyntheticEvent, newValue: string) => {
            switchTab(newValue);
        },
        [switchTab],
    );

    return { value, setValue, tabEnterKey, containerRef, switchTab, handleTabChange };
};

export default useDetailTabSwitch;
